/*
	Model for saving attributes of detail items currently displayed.
*/
import Backbone from 'backbone'

var DetailFilesItemModel = Backbone.Model.extend({})

export default DetailFilesItemModel
